import { HomeMainCompProps } from "../../../components/home-main-comp/home-main.comp";
import coverImage from "../../../assets/images/covers/mini/as-class.png";
/* IMAGE LIST */
import imgGoodies from "../../../assets/images/image-list/profile-img-list/mini/goodies.png";
import imgLmProject from "../../../assets/images/image-list/profile-img-list/mini/lm-project.png";
import imgMultiMe from "../../../assets/images/image-list/profile-img-list/mini/multi-me.png";
import imgOnTV from "../../../assets/images/image-list/profile-img-list/mini/on-tv.png";
import imgGoodiesMini from "../../../assets/images/image-list/profile-img-list/mini/goodies.png";
import imgLmProjectMini from "../../../assets/images/image-list/profile-img-list/mini/lm-project.png";
import imgMultiMeMini from "../../../assets/images/image-list/profile-img-list/mini/multi-me.png";
import imgOnTVMini from "../../../assets/images/image-list/profile-img-list/mini/on-tv.png";

/* ENGLISH */
export const profileCompEnglishData: HomeMainCompProps = {
  homeMainCompData: {
    label: "profile",
    title: "FENOHASINA",
    subtitle: "Jean Félicien <split/> Brillant",
    img: coverImage,
    button: [
      {
        label: "AS A DEVELOPER",
        value: "as-dev",
      },
      {
        label: "AS A GRAPHIC DESIGNER",
        value: "as-ig",
      },
    ],
    text: `
    In addition to being a fullstack developer <split/>+5 XP<split/>, I am also experienced in project management and user interface design.
`,
    imgList: [
      {
        link: imgOnTV,
        title: "SHARE",
        text: `
        I gave an interview to Dreaming TV about how to create a healthier internet for everyone.`,
        img: imgOnTVMini,
      },
      {
        link: imgLmProject,
        title: "PRIDE",
        text: `
        My source of pride is the feeling of satisfaction every time I complete a project.`,
        img: imgLmProjectMini,
      },
      {
        link: imgMultiMe,
        title: "CREATIVITY",
        text: `
        I believe that creativity is the greatest superpower.`,
        img: imgMultiMeMini,
      },
      {
        link: imgGoodies,
        title: "PASSION",
        text: `
        I love to explore my passions by participating in competitions.`,
        img: imgGoodiesMini,
      },
    ],
    children: (
      <span
        style={{
          display: "block",
          clear: "both",
          fontSize: "1.2rem",
          fontWeight: "bold",
          margin: "0.2rem",
        }}
      >
        My career
      </span>
    ),
  },
};

/* FRENCH */
export const profileCompFrenchData: HomeMainCompProps = {
  homeMainCompData: {
    label: "profile",
    title: "FENOHASINA",
    subtitle: "Jean Félicien <split/> Brillant",
    img: coverImage,
    button: [
      {
        label: "DEVELOPPEUR",
        value: "as-dev",
      },
      {
        label: "GRAPHIC DESIGNER",
        value: "as-ig",
      },
    ],
    text: `
    En plus d'être un développeur fullstack <split/>+5 XP<split/>, je suis également expérimenté en gestion de projet et en conception d'interface utilisateur.
`,
    imgList: [
      {
        link: imgOnTV,
        title: "PARTAGE",
        text: `
        J'ai donné une interview à Dreaming TV sur la façon de créer un internet plus sain pour tous.`,
        img: imgOnTVMini,
      },
      {
        link: imgLmProject,
        title: "FIERTE",
        text: `
        Ma source de fierté est le sentiment de satisfaction que j'éprouve chaque fois que je termine un projet.`,
        img: imgLmProjectMini,
      },
      {
        link: imgMultiMe,
        title: "CREATIVITE",
        text: `
        J'estime que la créativité est le plus beau des super pouvoirs.`,
        img: imgMultiMeMini,
      },
      {
        link: imgGoodies,
        title: "PASSION",
        text: `
        J'aime explorer mes passions en participant à des concours.`,
        img: imgGoodiesMini,
      },
    ],
    children: (
      <span
        style={{
          display: "block",
          clear: "both",
          fontSize: "1.2rem",
          fontWeight: "bold",
          margin: "0.2rem",
        }}
      >
        Ma carrière en tant que
      </span>
    ),
  },
};
